<template>
    <div>
        <div :tooltip="getTooltip()" flow="down" class="icon_goodnotes dark" @click="handleClick">
        </div>
        <ConfirmDialog
            v-model="is_dialog_visible"
            :title="c_title"
            :content="c_content"
            :confirm-url="external_link"
            :showConfirm="false"
            @confirm="onConfirm"
            @cancel="onCancel"
        />
    </div>
</template>

<script>

import api from "../special_websites/prihum/api";
import ConfirmDialog from "./ConfirmDialog.vue";
import {common} from "@mixins/common";

export default {
    name: "GoodNotes",
    mixins:[common],
    components: {ConfirmDialog},
    data() {
        return {
            c_title: "Notice",
            is_dialog_visible: false,
            c_content: "You are about to be redirected to Goodnotes. Do you want to proceed?",
            external_link: ''
        }
    },
    props: {
        resource_id: {
            type: String,
            required: true
        },
        tooltip_string: {
            type: String,
            default: "",
            required: false
        }
    },
    methods: {
        getTooltip() {
            return this.tooltip_string ? this.tooltip_string : '匯入至Goodnotes'
        },
        handleClick() {
            this.is_dialog_visible = true;
            this.external_link = api.syncToGoodNotes([this.resource_id]);
        },
        async onConfirm() {
            this.is_dialog_visible = false;
            // let signed_links = '';
            // try {
            //     EventBus.$emit("showGlobalLoading");
            //     // window.location.href = api.syncToGoodNotes([this.resource_id]);
            //     const response = await api.syncToGoodNotes([this.resource_id]);
            //     if (response.data) {
            //         signed_links = response.data;
            //     }
            //     if (!signed_links) {
            //         alert(this.lang(this.$t('Failed to go to GoodNotes. Please try again later.')));
            //     } else {
            //       // window.open(signed_links, "_blank");
            //         window.location.href = signed_links;
            //     }
            // }catch (e) {
            //     console.log('e', e);
            //     EventBus.$emit("hideGlobalLoading");
            // }finally {
            //     EventBus.$emit("hideGlobalLoading");
            // }
        },
        onCancel() {
            this.is_dialog_visible = false;
        }
    }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/GoodNotes.vue